import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <section class="min-h-screen pt-24 pb-16">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="fade-in-left text-center mb-12">
          <div class="inline-flex items-center gap-2 bg-primary/10 rounded-full px-4 py-2 mb-4">
            <svg class="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
            <span class="text-sm font-medium text-primary">تماس با ما</span>
          </div>
          <h2 class="text-3xl sm:text-4xl lg:text-5xl font-black mb-4">با ما در <span class="text-primary">ارتباط</span> باشید</h2>
          <p class="text-muted-foreground max-w-2xl mx-auto">برای مشاوره رایگان، ثبت‌نام یا هر سوال دیگری با ما تماس بگیرید</p>
        </div>

        <!-- Contact Cards -->
        <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12 stagger-children">
          <div *ngFor="let info of contactInfo" class="bg-card border border-border rounded-xl p-5 text-center space-y-3 sports-card">
            <div class="w-12 h-12 rounded-2xl flex items-center justify-center mx-auto" [ngClass]="info.bg">
              <span [innerHTML]="info.iconHtml"></span>
            </div>
            <h3 class="font-bold">{{ info.title }}</h3>
            <p *ngFor="let line of info.lines" class="text-sm text-muted-foreground">{{ line }}</p>
          </div>
        </div>

        <div class="grid lg:grid-cols-2 gap-8 mb-12">
          <!-- Form -->
          <div class="fade-in-left bg-card border border-border rounded-xl p-6 lg:p-8">
            <h3 class="text-xl font-bold mb-6 flex items-center gap-2">
              <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/></svg>
              ارسال پیام
            </h3>
            <form (ngSubmit)="onSubmit()" class="space-y-5">
              <div class="grid sm:grid-cols-2 gap-4">
                <div class="space-y-2">
                  <label class="text-sm font-medium">نام و نام خانوادگی</label>
                  <input type="text" placeholder="نام خود را وارد کنید" class="w-full h-10 rounded-lg bg-background border border-input px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring"/>
                </div>
                <div class="space-y-2">
                  <label class="text-sm font-medium">شماره تماس</label>
                  <input type="tel" placeholder="۰۹۱۲۳۴۵۶۷۸۹" class="w-full h-10 rounded-lg bg-background border border-input px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring"/>
                </div>
              </div>
              <div class="space-y-2">
                <label class="text-sm font-medium">ایمیل</label>
                <input type="email" placeholder="example@email.com" class="w-full h-10 rounded-lg bg-background border border-input px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring"/>
              </div>
              <div class="space-y-2">
                <label class="text-sm font-medium">موضوع</label>
                <input type="text" placeholder="موضوع پیام شما" class="w-full h-10 rounded-lg bg-background border border-input px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring"/>
              </div>
              <div class="space-y-2">
                <label class="text-sm font-medium">پیام</label>
                <textarea placeholder="پیام خود را بنویسید..." rows="5" class="w-full rounded-lg bg-background border border-input px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring resize-none"></textarea>
              </div>
              <button type="submit" class="w-full bg-primary text-primary-foreground py-3 rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-primary/90 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/></svg>
                ارسال پیام
              </button>
            </form>
          </div>

          <!-- Map & Socials -->
          <div class="fade-in-left space-y-6" style="animation-delay: 0.2s">
            <div class="rounded-xl overflow-hidden h-64 lg:h-72 relative">
              <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80" alt="نقشه" class="w-full h-full object-cover"/>
              <div class="absolute inset-0 bg-primary/20 flex items-center justify-center">
                <div class="bg-background/90 backdrop-blur-sm rounded-xl p-4 text-center">
                  <svg class="w-8 h-8 text-primary mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                  <p class="font-bold text-sm">تهران، خیابان ولیعصر</p>
                  <p class="text-xs text-muted-foreground">پلاک ۱۲۳، طبقه ۳</p>
                </div>
              </div>
            </div>
            <div class="bg-card border border-border rounded-xl p-6">
              <h3 class="text-lg font-bold mb-4 flex items-center gap-2">
                <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
                شبکه های اجتماعی
              </h3>
              <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
                <a *ngFor="let social of socials" class="flex flex-col items-center gap-2 p-4 rounded-xl bg-muted/50 hover:bg-muted transition-colors">
                  <div class="w-10 h-10 rounded-full flex items-center justify-center" [ngClass]="social.color">
                    <span [innerHTML]="social.iconHtml"></span>
                  </div>
                  <span class="text-xs font-medium">{{ social.name }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- FAQ -->
        <div class="fade-in-left">
          <div class="text-center mb-8">
            <h3 class="text-2xl font-bold">سوالات <span class="text-primary">متداول</span></h3>
          </div>
          <div class="grid sm:grid-cols-2 gap-4">
            <div *ngFor="let faq of faqs" class="bg-card border border-border rounded-xl p-5 sports-card">
              <h4 class="font-bold text-sm mb-2 flex items-start gap-2">
                <svg class="w-4 h-4 text-primary flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
                {{ faq.q }}
              </h4>
              <p class="text-sm text-muted-foreground leading-6 pr-6">{{ faq.a }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [':host { display: block; }']
})
export class ContactComponent {
  contactInfo = [
    { title: 'تلفن تماس', lines: ['۰۲۱-۸۸۷۷۶۶۵۵', '۰۹۱۲-۱۲۳۴۵۶۷'], bg: 'bg-red-500/10', iconHtml: '<svg class="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>' },
    { title: 'ایمیل', lines: ['info@parsfitness.ir', 'support@parsfitness.ir'], bg: 'bg-orange-500/10', iconHtml: '<svg class="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>' },
    { title: 'آدرس', lines: ['تهران، خیابان ولیعصر، پلاک ۱۲۳', 'طبقه ۳، واحد ۵'], bg: 'bg-amber-500/10', iconHtml: '<svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>' },
    { title: 'ساعات کاری', lines: ['شنبه تا پنج شنبه: ۶:۰۰ - ۲۳:۰۰', 'جمعه: ۸:۰۰ - ۲۰:۰۰'], bg: 'bg-emerald-500/10', iconHtml: '<svg class="w-6 h-6 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' },
  ];

  socials = [
    { name: 'اینستاگرام', color: 'bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500', iconHtml: '<svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>' },
    { name: 'تلگرام', color: 'bg-blue-500', iconHtml: '<svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/></svg>' },
    { name: 'واتساپ', color: 'bg-green-500', iconHtml: '<svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>' },
    { name: 'وب سایت', color: 'bg-gray-600', iconHtml: '<svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>' },
  ];

  faqs = [
    { q: 'آیا امکان رزرو آنلاین کلاس‌ها وجود دارد؟', a: 'بله، شما می‌توانید از طریق سایت یا اپلیکیشن ما، کلاس‌های مورد نظر خود را رزرو کنید و از مشاوره رایگان مربیان بهره‌مند شوید.' },
    { q: 'شهریه دوره‌ها شامل چه مواردی می‌شود؟', a: 'شهریه دوره‌ها شامل دسترسی به تمامی سالن‌ها و تجهیزات، حضور در کلاس‌های گروهی، یک جلسه ارزیابی بدنی ماهانه و مشاوره تغذیه رایگان است.' },
    { q: 'آیا برای مبتدیان کلاس مخصوصی وجود دارد؟', a: 'بله، ما کلاس‌های مخصوص مبتدیان در تمامی رشته‌ها داریم. مربیان ما با صبر و حوصله، تمرینات را از پایه شروع می‌کنند.' },
    { q: 'آیا پارکینگ رایگان دارید؟', a: 'بله، برای اعضا پارکینگ رایگان با ظرفیت ۱۰۰ خودرو در نظر گرفته شده است.' },
  ];

  onSubmit(): void {
    alert('پیام شما با موفقیت ارسال شد!');
  }
}
